import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import StoryCard from '@/components/feature/StoryCard';
import { stories } from '@/mocks/stories';

export default function LatestSection() {
  const latest = [...stories]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading
            eyebrow="最新更新"
            title="刚刚端上来的几盘瓜"
            desc="按发布时间排序，每一篇都标注了场景和阅读时长，适合通勤、睡前或者课间随手翻一篇。"
          />
          <Link
            to="/stories"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            进入趣闻列表 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}